import type React from "react";
import { Reveal } from "@/components/motion/motion";

/** Editorial case block: title pinned on the left, text on the right. */
export function CaseBlock({
	index,
	title,
	children,
}: {
	index: string;
	title: string;
	children: React.ReactNode;
}) {
	return (
		<Reveal className="grid gap-4 border-t pt-10 md:grid-cols-[16rem_1fr] md:gap-12">
			<div>
				<p className="font-mono text-xs text-signal-ink">{index}</p>
				<h2 className="mt-2 text-2xl font-semibold tracking-[-0.025em]">
					{title}
				</h2>
			</div>
			<div className="max-w-3xl space-y-5 text-lg text-pretty text-muted-foreground">
				{children}
			</div>
		</Reveal>
	);
}
